<template>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">{{ $t('sprint.titleList')}}</h1>
      <breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template #action>
      <button
        v-if="isSupport"
        class="button is-addOrEdit"
        @click="showPopupEdit = true">
        {{ $t('sprint.actions.add')}}
      </button>
    </template>
    <template #content>
      <qd-collapse
        v-for="sprint in items"
        :key="sprint.id"
        class="card mgt-20px"
        animation="slide"
        :aria-id="sprint.id"
        :open.sync="sprint.open">
        <div
          slot="trigger"
          slot-scope="props"
          class="card-header card-header-title has-text-default columns is-marginless "
          role="button">
            <div class="column is-4">
              {{sprint.titre}}
            </div>
            <div class="column is-2">
              {{ $t('sprint.dates', {
                debut: func.formatDate(sprint.dateAffichage),
                fin: func.formatDate(sprint.dateRetraitHomePage),
              })}}
            </div>
            <div class="column">
            </div>
            <div class="has-text-centered column is-narrow">
              <btn-action-icon v-if="isSupport"
                :permission="constantes.SPRINT.maj"
                @is-click="actionEditSprint(sprint)"
                icon-type="is-success"
                icon="pencil-box-outline">
              </btn-action-icon>
            </div>
            <div class="has-text-centered column is-narrow">
              <btn-action-icon v-if="isSupport"
                :permission="constantes.SPRINT.supprimer"
                @is-click="actionDeleteSprint(sprint)"
                icon-type="is-danger"
                icon="delete-forever">
              </btn-action-icon>
            </div>
            <a class="card-header-icon column is-narrow">
              <b-icon icon="chevron-right" class="animationChevron"
                      :class="{'rotationChevronOuvertureMenu': props.open }">
              </b-icon>
            </a>
        </div>
        <div class="card-content">
          <sprint-card :data="sprint" />
        </div>
      </qd-collapse>
    </template>
    <template #after-content>
      <b-modal v-if="isSupport"
        v-model="showPopupPreventionDelete"
        @close="sprintSelected = null"
        has-modal-card
        class="modal">
        <pop-up-prevention
          v-if="sprintSelected"
          :messHeader="$t('general.suppression.titre', { type: sprintSelected.titre })"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="showPopupPreventionDelete = false"
          @yes="deleteSprint()"/>
      </b-modal>
      <b-modal v-if="isSupport"
        v-model="showPopupEdit"
        @close="sprintSelected = null"
        class="modal"
        has-modal-card>
        <popup-add-edit-sprint
          :sprint="sprintSelected"
          @reload="recherche()"
        />
      </b-modal>
    </template>
  </liste-template>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { remove } from '@/api/sprint';
import Breadcrumb from '@/components/general/breadcrumb';
import BtnActionIcon from '@/components/general/btnActionIcon';
import ListeTemplate from '@/components/general/template/listeTemplate';
import PopUpPrevention from '@/components/general/popUpPrevention';
import PopupAddEditSprint from '@/components/parametrage/sprint/p_addEditSprint';
import formatDate from '@/services/general/formatDate';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import { SET_FORCE_LOAD, SET_LAST_UPDATE_HOME } from '@/store/modules/parametrage/sprint-mutation-type';
import { SPRINT } from '@/configuration/general/permissionsParametrageConf';
import SprintCard from '@/components/parametrage/sprint/sprintCard';

const user = createNamespacedHelpers('user');
const Sprint = createNamespacedHelpers('sprint');

export default {
  name: 'LSprint',
  components: {
    Breadcrumb,
    SprintCard,
    BtnActionIcon,
    ListeTemplate,
    PopUpPrevention,
    PopupAddEditSprint,
  },
  data() {
    return {
      constantes: {
        SPRINT,
      },
      func: {
        formatDate,
      },
      sprintSelected: null,
      showPopupEdit: false,
      showPopupPreventionDelete: false,
    };
  },
  computed: {
    ...user.mapGetters({
      isSupport: 'isSupport',
    }),
    ...Sprint.mapGetters({
      total: 'totalCount',
      items: 'items',
      forceLoad: 'forceLoad',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('sprint.titleList'), route: { name: '' }, isActive: true },
      ];
    },
  },
  methods: {
    ...Sprint.mapActions({
      actionsLoad: 'load',
    }),
    ...Sprint.mapMutations({
      setForceLoad: SET_FORCE_LOAD,
      setLastUpdateHome: SET_LAST_UPDATE_HOME,
    }),
    async recherche() {
      this.debutLoading();
      this.setForceLoad(true);
      const param = {
        limit: 6,
        orderBy: 'dateAffichage',
        ascending: 0,
      };
      await this.actionsLoad(param);
      this.finLoading();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    actionEditSprint(sprint) {
      sprint.open = !sprint.open;
      this.sprintSelected = sprint;
      this.showPopupEdit = true;
      this.setLastUpdateHome(null);
    },
    actionDeleteSprint(sprint) {
      sprint.open = !sprint.open;
      this.sprintSelected = sprint;
      this.showPopupPreventionDelete = true;
      this.setLastUpdateHome(null);
    },
    async deleteSprint() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(this.sprintSelected.id);
        messageSuccess(this.$t('sprint.addEdit.deleteSprintSuccess'));
        await this.recherche();
        this.showPopupPreventionDelete = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.sprintSelected = null;
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    await this.recherche();
    this.setInformationPage(this.$t('sprint.titleList'));
  },
};
</script>
